import Footer from "./Footer/Footer";
import NavBar from "./NavBar/NavBar";
import HeroSection from "./Sections/HeroSection";
import { lazy, Suspense } from "react";

const FeaturesSection = lazy(() => import("./Sections/FeaturesSection"));
const ServicesSection = lazy(() => import("./Sections/ServicesSection"));

const LandingContent = () => {
  return (
    <>
      <NavBar />
      <HeroSection />
      <Suspense fallback={<div>Loading ...</div>}>
        <FeaturesSection />
      </Suspense>
      <Suspense fallback={<div>Loading ...</div>}>
        <ServicesSection />
      </Suspense>
      <Footer />
    </>
  );
};

export default LandingContent;
